import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js'; // NOTE: if not using soy2js, replace with window.Yext = window.Yext || {};

import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js';
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { Image } from 'js/components/Image/index.js';
import { LocationHours } from 'js/components/LocationHours/index.js';
import { Maps } from 'js/components/Maps/index.js';
import { LocationMap } from 'js/location/locationMap.js';
import 'script-loader!node_modules/slick-carousel/slick/slick.js';

import { Instance as MapsAPI } from 'js/components/Maps/GoogleMapsAPI.js';
Yext.Maps = Maps;
Yext.Maps.LocationMap = LocationMap;

Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  Yext.Maps.loadAndRun();
  LocationHours.loadAndRun();
  MapsAPI.load();

  $('.js-slick-featuredCategories-carousel').slick({
    dots: true,
    infinite: false,
    adaptiveHeight: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          variableWidth: true
        }
      }
    ]
  });

  $('.js-slick-loyaltyBanners-carousel').slick({
    dots: true,
    infinite: false,
    adaptiveHeight: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          variableWidth: true
        }
      }
    ]
  });

    // Enable smooth scrolling for anchor link
  $('.js-smoothScroll').on('click', function() {
    if ((location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')) && (location.hostname === this.hostname)) {
      let target = $(this.hash);
      target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
      if (target.length) {
        $('html,body').animate({ scrollTop: target.offset().top }, 1000);
        return false;
      }
    }
  });

  // Set up Faqs dropdowns
  const faq = document.querySelector('.js-faq');
  const fqaContainer = document.getElementById('faq');
  if (faq) {
      const top = faq.querySelector('.js-faqTitle');
      const bottom = faq.querySelector('.js-faqExpand');
      if (top && bottom) {
        top.addEventListener('click', () => {
          const isCollapsing = bottom.classList.contains('is-visible');
          bottom.classList.toggle('is-visible');
          top.classList.toggle('is-expanded');
          if (isCollapsing) {
            bottom.setAttribute('aria-hidden', 'true');
            top.setAttribute('aria-expanded', 'false');
            fqaContainer.style.display = 'none';
          } else {
            bottom.setAttribute('aria-hidden', 'false');
            top.setAttribute('aria-expanded', 'true');
            fqaContainer.style.display = 'block';
          }
        });
      }
  }

  // Set up About dropdowns
  const about = document.querySelector('.js-about');
  const aboutContainer = document.getElementById('about');
  if (about) {
      const top = about.querySelector('.js-title');
      const bottom = about.querySelector('.js-aboutExpand');
      if (top && bottom) {
        top.addEventListener('click', () => {
          const isCollapsing = bottom.classList.contains('is-visible');
          bottom.classList.toggle('is-visible');
          top.classList.toggle('is-expanded');
          if (isCollapsing) {
            bottom.setAttribute('aria-hidden', 'true');
            top.setAttribute('aria-expanded', 'false');
            aboutContainer.style.display = 'none';
          } else {
            bottom.setAttribute('aria-hidden', 'false');
            top.setAttribute('aria-expanded', 'true');
            aboutContainer.style.display = 'flex';
          }
        });
      }
  }

  // Set up the Show More and Show Less button functionality for the FAQ section.
  const faqWrapper = document.querySelector('.Faq-cardWrapper');
  const faqCards = faqWrapper.querySelectorAll('.Faq-card');
  const showMoreButton = document.getElementById('showMoreBtn');
  const showLessButton = document.getElementById('showLessBtn');

  const initialVisibleCount = 5;

  // Initially show only the first 5 FAQ cards
  for (let i = 0; i < initialVisibleCount && i < faqCards.length; i++) {
    faqCards[i].classList.add('show');
  }

  // Show More button click event - Show all FAQ cards
  showMoreButton.addEventListener('click', function() {
    faqCards.forEach(card => {
      card.classList.add('show');
    });

    showMoreButton.style.display = 'none'; // Hide the Show More button
    showLessButton.style.display = 'block'; // Show the Show Less button
  });

  // Show Less button click event - Show only the first 5 FAQ cards again
  showLessButton.addEventListener('click', function() {
    // Hide all FAQ cards except the first 5
    faqCards.forEach((card, index) => {
      if (index >= initialVisibleCount) {
        card.classList.remove('show');
      }
    });

    showLessButton.style.display = 'none'; // Hide the Show Less button
    showMoreButton.style.display = 'block'; // Show the Show More button
  });

  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
});
